import * as React from "react";
import { ErrataView } from "../service/index.js";
import { WidgetFrame } from "./WidgetFrame.jsx";
export { ErrataWidget, ErrataView };
/**
 * Вывод отчёта об ошибках как секции учебного продукта.
 * @param {Object} props - Атрибуты элемента.
 * @param {Errata} props.errata - Отчёт об ошибке.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * import {ErrataWidget} from "../personal-studio-components/studio/index.js";
 * if(request.hasError()) return <ErrataWidget errata={request.getErrata()}/>;
 * @see {@link ../service/ErrataView.jsx}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function ErrataWidget(
  {
    errata = {}
  }) {
  const title = error_type_title[errata.error_type] ?? error_type_title["*"];
  const icon = error_type_icon[errata.error_type] ?? error_type_icon["*"];
  const style = error_type_style[errata.error_type] ?? error_type_style["*"];
  return (
    <WidgetFrame
      type={style}
      icon={icon}
      title={title}>
      <ErrataView errata={errata} />
    </WidgetFrame>
  );
}
const error_type_title = {
  "info": "Информация",
  "warning": "Предупреждение",
  "*": "Произошла ошибка"
};
const error_type_icon = {
  "info": "info",
  "*": "warn"
};
const error_type_style = {
  "info": "blue",
  "warning": "yellow",
  "*": "danger"
};
